<app-breadcrumb [title]="'Wishlist'|translate" [breadcrumb]="'Wishlist'|translate"></app-breadcrumb>
<!--section start-->
<section class="wishlist-section section-b-space">
    <div class="container">
        <div class="col-md-12 empty-cart-cls text-center" *ngIf='!(wishLists$ |async)'>
            <img src="assets/images/empty-wishlist.png" alt="Empty cart" title="Emprt cart">
            <h3 class="mt-4"><b>{{'Wishlist is Empty'|translate}}</b></h3>
            <h4>{{'Explore more shortlist some items.'|translate}}</h4>
        </div>


        <div class="container" *ngIf="(wishLists$|async) as cartItems;">


            <div class="row">
                <div class="col-sm-12">
                    <table class="table">
                        <thead>
                            <tr class="table-head">
                                <th scope="col">{{'image'|translate}}</th>
                                <th scope="col">{{'Product Name'|textLength|translate}}</th>
                                <th scope="col">{{'Price'|translate}}</th>
                                <th scope="col">{{'Action'|translate}}</th>
                            </tr>
                        </thead>
                        <tbody *ngFor="let product of cartItems">
                            <tr [ngStyle]="{'border': product.quantitiesInCartItem>product.stock?'5px solid red':''}">
                                <td>
                                    <a [routerLink]="['/shop/product/left/sidebar/', product.barcode]">
                                        <img [src]="product.imageName">
                                    </a>
                                </td>
                                <td>
                                    <a [routerLink]="['/shop/product/left/sidebar/', product.barcode]">{{
                                        product.productName | titlecase }}</a>
                                    <div class="mobile-cart-content row">
                                        <div class="col-xs-3">
                                            <div class="qty-box">
                                                <div class="input-group">
                                                    <input type="text" name="quantity" class="form-control input-number"
                                                        disabled [(ngModel)]="product.quantitiesInCartItem">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xs-3">
                                            <h2 class="td-color">
                                                {{ (product.unitPrice | discount:product) |
                                                currency:productService?.Currency.currency:'symbol' }}
                                            </h2>
                                        </div>

                                        <div class="col-xs-3">
                                            <h2 class="td-color">
                                                <a (click)="removeItem(product)" class="icon">
                                                    <i class="ti-close"></i>
                                                </a>
                                            </h2>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <h2>
                                        {{ (product.unitPrice | discount:product) |
                                        currency:productService?.Currency.currency:'symbol' }}
                                    </h2>
                                </td>

                                <td>
                                    <button type="button" style="cursor: pointer;" (click)="removeItem(product)"
                                        class="icon">
                                        <i class="ti-close"></i>
                                    </button>
                                </td>


                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>

            <div class="row cart-buttons" *ngIf='cartItems.length'>
                <div class="col-6">
                    <a [routerLink]="['/shop/product/noValue']" class="btn btn-solid">continue shopping</a>
                </div>

            </div>
        </div>



        <div class="row wishlist-buttons" *ngIf='products.length'>
            <div class="col-12">
                <a [routerLink]="['/shop/product/noValue']" class="btn btn-solid">continue shopping</a>
                <!-- <a [routerLink]="['/shop/checkout']" class="btn btn-solid">check out</a> -->
            </div>
        </div>
    </div>
</section>
<!--section end-->